import { Flex } from "#shared/view/components/Flex";
import { Grid } from "#shared/view/components/Grid";
import { Stack } from "#shared/view/components/Stack";
import { Skeleton } from "#shared/view/designSystem/Skeleton";

export const QuoteRequestLineSkeleton = () => {
  return (
    <Grid w={"100%"}>
      <Grid.Col span={3}>
        <Flex h="100%" gap={"xs"} align={"center"}>
          <Skeleton height={53} width={70} radius="xs" />

          <Stack gap="xs" justify="center" w={"100%"}>
            <Skeleton height={24} radius="xl" />
            <Flex gap="xs">
              <Skeleton height={16} radius="xl" />
              <Skeleton height={16} radius="xl" />
            </Flex>
          </Stack>
        </Flex>
      </Grid.Col>

      <Grid.Col span={3}>
        <Flex h="100%" gap={"xs"} align={"center"}>
          <Stack w={"100%"} gap={"xs"}>
            <Skeleton height={8} radius="xs" />
            <Skeleton height={40} radius="xs" />
          </Stack>
          <Stack w={"100%"} gap={"xs"}>
            <Skeleton height={8} radius="xs" />
            <Skeleton height={40} radius="xs" />
          </Stack>
        </Flex>
      </Grid.Col>

      <Grid.Col span={6}>
        <Flex h="100%" align={"center"} gap={"xs"} justify={"end"}>
          <Flex justify={"end"}>
            <Stack h="100%" w="100%" gap="5">
              <Skeleton height={16} width={160} radius="xl" />
              <Skeleton height={28} width={90} radius="xl" />
              <Skeleton height={12} width={60} radius="xl" />
            </Stack>
          </Flex>
          <Skeleton height={20} width={30} radius="xl" />
        </Flex>
      </Grid.Col>
    </Grid>
  );
};
